import { Controller } from "@hotwired/stimulus"

// Hides an element and remembers the choice in localStorage.
export default class extends Controller {
  static values = {
    key: String,
  }

  connect() {
    if (this.#dismissed()) this.element.hidden = true
  }

  dismiss(event) {
    event?.preventDefault()
    try {
      localStorage.setItem(this.keyValue, "1")
    } catch (_error) {
      // Private mode / blocked storage — still hide for this page view.
    }
    this.element.hidden = true
  }

  #dismissed() {
    try {
      return localStorage.getItem(this.keyValue) === "1"
    } catch (_error) {
      return false
    }
  }
}
